module.exports = __webpack_public_path__ + "static/media/logo-on-dark-mobile-wide.ce3d5315.svg";